import { useQuery } from '@tanstack/react-query'
import { SelectOptionData } from '@veracity/vui'

import {
  financesClient,
  incomeAdjustmentClient,
  lossFactorsClient,
  otherBessInputsLibraryClient,
  productionProfilesClient,
  wholesaleMarketClient
} from '@/api'
import { DatasetSimple, SourceTypes } from '@/interfaces'

export const useScenarioLibrariesDictionaries = () => {
  const wholesaleQuery = useQuery({
    queryKey: [...wholesaleMarketClient.QUERY_KEY, { lockedOnly: true }],
    queryFn: () => wholesaleMarketClient.getAll(true)
  })

  const financesQuery = useQuery({
    queryKey: [...financesClient.QUERY_KEY, { lockedOnly: true }],
    queryFn: () => financesClient.getAll(true)
  })

  const incomeAdjustmentQuery = useQuery({
    queryKey: [...incomeAdjustmentClient.QUERY_KEY, { lockedOnly: true }],
    queryFn: () => incomeAdjustmentClient.getAll(true)
  })

  const lossFactorsQuery = useQuery({
    queryKey: [...lossFactorsClient.QUERY_KEY, { lockedOnly: true }],
    queryFn: () => lossFactorsClient.getAll(true)
  })

  const productionProfilesPv = useQuery({
    queryKey: [
      ...productionProfilesClient.QUERY_KEY,
      { lockedOnly: true, type: SourceTypes.Solar }
    ],
    queryFn: () => productionProfilesClient.getAll(true, SourceTypes.Solar)
  })

  const productionProfilesWind = useQuery({
    queryKey: [
      ...productionProfilesClient.QUERY_KEY,
      { lockedOnly: true, type: SourceTypes.Wind }
    ],
    queryFn: () => productionProfilesClient.getAll(true, SourceTypes.Wind)
  })

  const otherBessInputs = useQuery({
    queryKey: [...otherBessInputsLibraryClient.QUERY_KEY, { lockedOnly: true }],
    queryFn: () => otherBessInputsLibraryClient.getAll(true)
  })

  const convertToOptions = (datasets: DatasetSimple[]) =>
    datasets.map(x => ({ text: x.name, value: x.id }) as SelectOptionData)

  return {
    wholesaleMarket: convertToOptions(wholesaleQuery.data || []),
    finances: convertToOptions(financesQuery.data || []),
    incomeAdjustment: convertToOptions(incomeAdjustmentQuery.data || []),
    lossFactors: convertToOptions(lossFactorsQuery.data || []),
    productionProfilesPv: convertToOptions(productionProfilesPv.data || []),
    productionProfilesWind: convertToOptions(productionProfilesWind.data || []),
    otherBessInputs: convertToOptions(otherBessInputs.data || [])
  }
}
